module.exports = __webpack_public_path__ + "static/meta/sqs/2019/layout_metadata.0608ac3.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2019/meta/layout_metadata.tsv
// module id = TGfh
// module chunks = 0